jQuery.noConflict();

var initAutocomplete, geolocate;
var placeSearch, autocomplete;
(function($, window) {
    var adjustAnchor = function() {

        var $anchor = $(':target'),
            fixedElementHeight = 300;

        if ($anchor.length > 0) {

            $('html, body')
                .stop()
                .animate({
                    scrollTop: $anchor.offset().top - fixedElementHeight
                }, 200);

        }

    };

    $(window).on('hashchange load', function(e) {
        e.preventDefault();
        adjustAnchor();
    });

})(jQuery, window);
(function($) {

    /* * * * * * * * * * * * * * * * * *
* Show/hide fields conditionally
* * * * * * * * * * * * * * * * * */
    (function($) {
        $.fn.conditionize = function(options){

            var settings = $.extend({
                hideJS: true
            }, options );

            $.fn.showOrHide = function(listenTo, listenFor, $section) {

                if ($(listenTo).is('select, input[type=text]') && $(listenTo).val() == listenFor) {
                    $section.slideDown();
                    $($section).find('.form-control, .form-check-input').prop("disabled", false);

                } else if ($(listenTo + ":checked").val() == listenFor) {
                    $section.slideDown();

                    $($section).find('.form-control, .form-check-input').prop("disabled", false);
                } else {
                    $section.slideUp();
                    $($section).find('.form-control, .form-check-input').prop("disabled", true);
                }
            };

            return this.each( function() {
                var listenTo = "." + $(this).data('cond-option');
                var listenFor = $(this).data('cond-value');
                var $section = $(this);

                //Set up event listener
                $(listenTo).on('change', function() {
                    $.fn.showOrHide(listenTo, listenFor, $section);
                });
                //If setting was chosen, hide everything first...
                if (settings.hideJS) {
                    $(this).hide();
                }
                //Show based on current value on page load
                $.fn.showOrHide(listenTo, listenFor, $section);
            });
        }
    }(jQuery));

    $('.conditional').conditionize();


    $(document).ready(function(){

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

        $(".gallery-icon a").fancybox();

        (function () {
            $('#employment-select').on('change', function () {
                let $that = $(this);

                $('#OccupationId').val($that.find(':selected').data('occupationid'));
                $('#RiskyOccupation').val($that.find(':selected').data('isrisk'));
                $('#OccupationRiskClass').val($that.find(':selected').data('category'));
            });
        })();

        (function () {
            $('#hoby-select').on('change', function () {
                let $that = $(this);

                $('#HobbyId').val($that.find(':selected').data('hobbyid'));
                $('#RiskyHoby').val($that.find(':selected').data('riskyhoby'));
            });
        })();



        (function () {
            $('.book-strategy-wrapper .btn, .book-strategy-cta').on('click', function (e) {
                e.preventDefault();
                $('#contact-modal').modal();
            })
        })();

        $(document).on('click', '#wrapper-navbar .dropdown-menu', function (e) {
            e.stopPropagation();
        });

        $(function () {
            $('[data-toggle="popover"]').popover();
        });

        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }


        (function () {
            $('#sms-verification').on('click', function(e) {
                e.preventDefault();
                let $that = $(this);
                let phone = $that.attr('data-phone');

                let data = {
                    'phone': phone,
                };

                $that.addClass('disabled');

                /* ajaxHelper(data, 'send_auth_code').then((response) => {
                    console.log(response);
                    $that.removeClass('disabled');
                }, (response) => {
                    console.log(response);
                }); */
            });
        })();


        (function () {
            $('#subscribe-form').on('submit', function(e) {
                e.preventDefault();
                let $that = $(this),
                    $noticeWrapper = $that.find('.newsletter-msg'),
                    $honey = $that.find('#b_31c7ce87dd149729f78dbb99e_ad09da451d');

                if ($honey.val() || !$that.find('#holder-email').val()) {
                    return false;
                }

                let data = {
                    'email': $that.find('#holder-email').val(),
                };


                ajaxHelper(data, 'newsletter_signup').then((response) => {
                    // console.log(response);
                    $noticeWrapper.html(response.msg);
                    // $that.removeClass('disabled');
                }, (response) => {
                    console.log(response);
                });
            });
        })();


        (function () {
            if ($('#InsuranceDuration').val() >= 10) {
                $('.tax-conditional').hide();
            } else {
                $('.tax-conditional').show();
            }

            $('#konfigurator-form').on('change', function () {
                $('.advice').removeClass('confirm').removeClass('deny');

                if ($('#not-financial-burder').is(':checked') || $('#no-dependency').is(':checked')) {
                    $('.advice').addClass('deny');
                } else if($('#financial-burder').is(':checked') && $('#dependency').is(':checked')) {
                    $('.advice').addClass('confirm');
                }

                if ($('#InsuranceDuration').val() >= 10) {
                    $('.tax-conditional').hide();
                } else {
                    $('.tax-conditional').show();
                }

                if ($('input[name="konfigurator[trajnost]"]').is(':checked')) {                  

                    $('.trajnost .card').addClass('d-none');

                    $('input[name="konfigurator[trajnost]"]').each(function() {
                        if ($(this).is(':checked')) {
                            let id = $(this).attr('id');

                            $(`#${ id }-card`).removeClass('d-none');
                        }
                    });
                }
            });
        })();



        (function() {
            const $ponudnikiMap = $('#ponudniki-map');

            if($ponudnikiMap.length > 0) {
                window.ponudnikiMap = new GMaps({
                    div: '#ponudniki-map',
                    lat: 46.0569,
                    lng: 14.5058,
                    zoom: isMobile ? 8 : 9
                });

                if (typeof ponudniki !== 'undefined') {
                    drawMarketsOnMap(ponudniki);

                }
            }


        })();

        $('#open-ponudniki-search').on('click', function (e) {
            e.preventDefault();

            $(this).hide();

            $('#iskalnik-wrapper').show();
        });

        function drawMarketsOnMap(ponudniki) {
            if (!ponudniki) {
                return false;
            }



            ponudniki.forEach(function(ponudnik) {
                // console.log(ponudnik.location.lat);
                if(ponudnik.location.lat && ponudnik.location.lng) {
                    window.ponudnikiMap.addMarker({
                        lat: ponudnik.location.lat,
                        lng: ponudnik.location.lng,
                        title: ponudnik.name,

                        details: {
                            'ponudnikId': ponudnik.id
                        },
                        infoWindow: {
                            content: '<div class="d-flex flex-column" data-test="2"><span class="location-title mb-2">' + ponudnik.name + '</span><span class="location-address">' + ponudnik.location.address + '</span> <span class="d-block">'+ponudnik.phone + '</span> <span class="d-block"> ' + ponudnik.email +'</span></div>',
                            zIndex: -1
                        },

                        mouseover: function () {
                            this.setZIndex(10);
                            // $(this).parent().hide();
                        },
                        mouseout: function () {
                            this.setZIndex(1);
                        },
                    });
                }

            });
        }
        var formatContent = function () {
            return 'yay';
        };

        $('.kombinacija-cost.empty').on('click', function (e) {
            e.preventDefault();
            let $that = $(this);

            $('#age-modal').modal('show');
        });

        $('#age-form-ajax').on('submit', function (e) {
            e.preventDefault();
        }).on('change', function (e) {
            e.preventDefault();

            let age = $('#age-ajax').val();

            let data = {
                'age': age,
            };

            ajaxHelper(data, 'set_age_ajax').then((response) => {
                location.reload();
            }, (response) => {

            });
        });

        function get_bank_details(trr) {
            if (!trr) {
                return false;
            }

            const banke = {
                '05': {
                    'naziv': 'ABANKA VIPA d.d.',
                    'bic': 'ABANSI2XXXX'
                },
                '33': {
                    'naziv': 'ADDIKO BANK D.D.',
                    'bic': 'HAABSI22XXX'
                },
                '10': {
                    'naziv': 'BANKA INTESA SANPAOLO d.d.',
                    'bic': 'BAKOSI2XXXX'
                },
                '01': {
                    'naziv': 'BANKA SLOVENIJE',
                    'bic': 'BSLJSI2XXXX'
                },
                '34': {
                    'naziv': 'BANKA SPARKASSE D.D.',
                    'bic': 'BSLJSI2XXXX'
                },
                '35': {
                    'naziv': 'BKS BANK AG, podružnica Ljubljana',
                    'bic': 'BFKKSI22XXX'
                },
                '61': {
                    'naziv': 'DELAVSKA HRANILNICA D.D.',
                    'bic': 'HDELSI22XXX'
                },
                '19': {
                    'naziv': 'DEŽELNA BANKA SLOVENIJE d.d.',
                    'bic': 'SZKBSI2XXXX'
                },
                '07': {
                    'naziv': 'GORENJSKA BANKA d.d.',
                    'bic': 'GORESI2XXXX'
                },
                '60': {
                    'naziv': 'HRANILNICA LON d.d.',
                    'bic': 'HLONSI22XXX'
                },
                '04': {
                    'naziv': 'NOVA KREDITNA BANKA MARIBOR d.d.',
                    'bic': 'KBMASI2XXXX'
                },
                '02': {
                    'naziv': 'NOVA LJUBLJANSKA BANKA d.d.',
                    'bic': 'LJBASI2XXXX'
                },
                '64': {
                    'naziv': 'PRIMORSKA HRANILNICA VIPAVA d.d.',
                    'bic': 'HKVISI22XXX'
                },
                '30': {
                    'naziv': 'SBERBANK BANKA d.d.',
                    'bic': 'SABRSI2XXXX'
                },
                '03': {
                    'naziv': 'SKB BANKA d.d.',
                    'bic': 'SKBASI2XXXX'
                },
                '29': {
                    'naziv': 'UNICREDIT BANKA SLOVENIJE D.D.',
                    'bic': 'BACXSI22XXX'
                },
            };

            let trrStr = trr.toString();

            trrStr = trrStr.replace(/\s/g, '');
            trrStr = trrStr.substr(4);

            let bankCode = trrStr.slice(0, 2);

            return banke[bankCode];
        }

        $('#Iban').mask('SS00 0000 0000 0000 0000 00');
        $('#payer-phone, #holder-phone').mask('000000000');


        let numberMasks = [];

        (function () {
            if ($('.convertNumber').length > 0) {
                for (let i = 0; i < jQuery('.convertNumber').length; i++) {
                    numberMasks.push(IMask($('.convertNumber').get(i), {
                        mask: Number,  // enable number mask
    
                        // other options are optional with defaults below
                        scale: 2,  // digits after point, 0 for integers
                        signed: true,  // disallow negative
                        thousandsSeparator: '.',  // any single char
                        padFractionalZeros: true,  // if true, then pads zeros at end to the length of scale
                        normalizeZeros: true,  // appends or removes zeros at ends
                        radix: ',',  // fractional delimiter
                        mapToRadix: ['.'],  // symbols to process as radix
    
                        // additional number interval options (e.g.)
                        min: 0,
                    }));
                }

                
            }
        })();

        if (jQuery('#Iban').length) {
            if (jQuery('#Iban').val().length !== 0 && !jQuery('#Iban').val().startsWith('SI')) {
                jQuery('#Bic').attr('readonly', false);
                jQuery('#Bic').removeClass('disable-label-on-click');

                jQuery('#BankName').attr('readonly', false);
                jQuery('#BankName').removeClass('disable-label-on-click');
            }
        }

        $('#Iban').on('keyup', function () {
            let val = $(this).val();

            if (jQuery(this).val().toUpperCase().startsWith('SI')) {
                jQuery('#Bic').attr('readonly', true);
                jQuery('#Bic').addClass('disable-label-on-click');

                jQuery('#BankName').attr('readonly', true);
                jQuery('#BankName').addClass('disable-label-on-click');



                let bankDetails = get_bank_details($(this).val()),
                    $noticeWrapper = $(this).siblings('.notice-wrapper');

                if (!RE.util.Validators.isValidIBAN(val)) {
                    $noticeWrapper.html('Številka računa ni pravilna, ali ste vnesli številko računa čigar banke ne podpiramo.');

                    jQuery(this).addClass('form-validation-error');

                    return;
                }


                if (bankDetails) {
                    $('#Bic').val(bankDetails.bic);
                    $('#BankName').val(bankDetails.naziv);
                    $noticeWrapper.html('');

                    $('#Bic').addClass('input-has-value');
                    $('#BankName').addClass('input-has-value');
                } else {
                    $noticeWrapper.html('Številka računa ni pravilna, ali ste vnesli številko računa čigar banke ne podpiramo.');
                    jQuery(this).addClass('form-validation-error');
                    $(this).val('');
                    $('#Bic').val('');
                    $('#BankName').val('');
                }

            } else if (jQuery(this).val().length >= 2) {
                jQuery('#Bic').removeAttr('readonly');
                jQuery('#Bic').removeClass('disable-label-on-click');

                jQuery('#BankName').removeAttr('readonly');
                jQuery('#BankName').removeClass('disable-label-on-click');
            }
        });
        


        $('.trigger-phone').on('click', function () {
            let $that = $(this);
            let phone = $that.attr('data-phone');

            let data = {
                'phone': phone,
            };

/*             ajaxHelper(data, 'send_auth_code').then((response) => {

            }, (response) => {

            }); */
        });

        //validations
        (function () {
            const $submit = $('#konf-submit-btn');
            const $zzzs = $('#zzzs');

            $('#davcna_st').on('change', function () {
                /* let $noticeWrapper = $(this).siblings('.notice-wrapper');

                if (RE.util.Validators.isValidTaxNumber($(this).val())) {
                    $submit.attr('disabled', false);
                    $noticeWrapper.html('');
                } else {
                    $submit.attr('disabled', 'disabled');
                    $noticeWrapper.html('Davčna številka ni pravilna');
                } */
            });

            $zzzs.mask('000000000');
            $zzzs.on('change', function () {
                let $noticeWrapper = $(this).siblings('.notice-wrapper');

                if (RE.util.Validators.isValidNumberModul11($(this).val(),9)) {
                    $submit.attr('disabled', false);
                    $noticeWrapper.html('');
                } else {
                    $submit.attr('disabled', 'disabled');
                    $noticeWrapper.html('Številka zdravstvenega zavarovanja ni pravilna');
                }
            });
        })();

/*         $('#konfigurator-form-complete').on('submit', function (e) {
            e.preventDefault();
            const $that = $(this);

            let $noticeWrapper = $('#verification_code').siblings('.notice-wrapper'),
                $submitModal = $('#config-submit-modal');

            let data = {
                'code': $that.find('#verification_code').val()
            };

            ajaxHelper(data, 'verify_confirmation_code').then((response) => {
                if (response.success === true) {
                    $noticeWrapper.hide();
                    //If auth code is correct, proceed to submitting the form
                    $submitModal.modal({
                        backdrop: 'static',
                        keyboard: false
                    });

                    ajaxHelper(data, 'submit_conf_form').then((response) => {
                        
                        if (response.success === true) {
                            $submitModal.find('.waiting').hide();
                            $submitModal.find('.done').show();
                            //If auth code is correct, proceed to submitting the form
                        } else {

                        }
                    }, (response) => {
                        console.log(response);
                    });
                } else {
                    console.log('Auth code incorrect');
                    $noticeWrapper.show();
                }
            }, (response) => {
                console.log(response);
            });
        }); */

        (function () {

            let $dateField = $('.datefield');

            if($dateField.length > 0) {

                let options = {
                    dateFormat: "d.m.Y",
                    locale: 'sl',
                    allowInput:true,
                    // altInput: true,
                    // altFormat,
                    // allowInput: true,
                };


                const f = $dateField.flatpickr(options);
                // f._input.onkeypress = () => false;


                if (isMobile) {
                    $dateField.on('change', function () {
                        
                        let $fields = $(this).closest('.form-group').find('.datefield');
                        if ($(this).val()) {
                        
                            $fields.addClass('has-val');
                        } else {
                        
                            $fields.removeClass('has-val');
                        }
                    });
                } else {
                    //Not mobile
                    // $dateField.mask('00.00.0000');
                    // f._input.addEventListener('blur', function (event) {
                    //     f.setDate(f._input.value);
                    // }, true);

                }
            }



        })();

        //Paket select
        (function () {
            let $card = $('.paket-card:not(.elementor-table-item)'),
                $izbiraWrapper = $('#izbira-zavarovanja-wrapper');

            $card.on('click', function (e) {
               e.preventDefault();

               let $that = $(this),
                   $kritje = $that.closest('.kritje'),
                   $selectControl = $kritje.find('.kritje-select-control'),
                   $selectedPaketWrapper = $kritje.find('.selected-paket-wrapper'); //Wrapper where the selected "paket" name should be placed


                //Basic styling (red on selected)
               $kritje.find('.paket-card').not(this).removeClass('selected');
               $that.toggleClass('selected');

               let selectedPackage = $that.attr('data-key'),
                    kritjeKey = $that.attr('data-parent');

               if ($selectControl.val() === selectedPackage) {
                   $selectControl.val('');
               } else {
                   $selectControl.val(selectedPackage);
               }


               let selectedHelper = $selectControl.val();

                //Triggers a custom event whenever a "paket" is selected
                $izbiraWrapper.trigger('custom', [kritjeKey, selectedHelper]);


               let paketName = $('.paket-card[data-key="'+ selectedHelper + '"]').find('.paket-title').html();



                $selectedPaketWrapper.html(paketName);


               let activeKritja = $izbiraWrapper.data('selected-kritja');

               if (activeKritja !== undefined) {

                   if (activeKritja.length > 0) {
                       $izbiraWrapper.addClass('has-selection');
                   } else {
                       $izbiraWrapper.removeClass('has-selection');
                   }

                   $('.kritje').removeClass('is-selected');

                   activeKritja.forEach(activeKritje => {
                       // console.log(activeKritje);
                       $('#'+activeKritje).closest('.kritje').addClass('is-selected');
                   });
               }

                $izbiraWrapper.trigger('custom', [kritjeKey, selectedHelper]);


            });
        })();


        //Controls how the card loses it's shadow when expanded
        $('.kritja-accordion .kritje-collapsible').on('show.bs.collapse hide.bs.collapse', function () {
            $(this).closest('.card.kritje').toggleClass('expanded');
        });

        $('#age-form').on('change', function () {
            let age = $(this).find('#age').val(),
                $izbiraZavarovanja = $('#izbira-zavarovanja-wrapper'),
                ageString = $(this).find('option:selected').html(),
                $ageGroup = $('#age-group');

            let data = {
                'age': age,
            };

            if ($ageGroup.length > 0) {
                $ageGroup.val(age);
            }

            ajaxHelper(data, 'fetch_all_prices').then( (response) => {
                $izbiraZavarovanja.removeClass('disabled');
                for (const kritje of Object.keys(response)) {

                    let paketArr = response[kritje];
                    let $kritjeItem,
                        $paketItem;
                    paketArr.forEach(paketObj => {
                        $kritjeItem = $('#' + kritje);
                        $paketItem = $kritjeItem.find('.paket-card[data-key="'+paketObj.paket+'"]');
                        let price = paketObj.price.toString();
                        price = price.replace('.', ',');

                        $paketItem.addClass('has-price').addClass('enabled').removeClass('missing-price').find('.price').text(price + ' EUR');
                        $paketItem.find('.age-range-wrapper').text(ageString);

                        if (paketObj.price === 0) {
                            $paketItem.removeClass('enabled').addClass('missing-price');
                        }
                    });

                }
                // for (const value of Object.values(response)) {
                //     console.log(value);
                // }

                let $kritja = $('.kritje.card'),
                    $singleKritje;

                $kritja.removeClass('disabled');

                $kritja.each(function (i, v) {
                    $singleKritje = $(v);

                    let count = $singleKritje.find('.enabled').length;

                    if (count === 0) {
                        $singleKritje.addClass('disabled').find('.collapse').collapse('hide');
                    }
                });
            }, (response) => {
                console.log(response);
            });
        }).on('submit', function (e) {
            e.preventDefault();
        });


        //Elementor specific age form
        $('#age-form-elementor').on('change', function () {
            let age = $(this).find('#age').val(),
                ageString = $(this).find('option:selected').html();

            let data = {
                'age': age,
            };

            ajaxHelper(data, 'set_age_ajax').then((response) => {
                location.reload();
            }, (response) => {

            });
        }).on('submit', function (e) {
            e.preventDefault();
        });


        //FAQ Search
        (function () {
            let $searchBox = $('#faq-search'),
                $fWrapper = $('#faq-wrapper'),
                $noResults= $('#no-results');

            if ($fWrapper.length > 0) {
                var $answers = $fWrapper.find('article.faq'),
                    $catHeadings = $fWrapper.find('.cat-title');
            }

            let data = [];

            let showResults = function (ids) {
                if (!ids) return;
                //ids is an array of active faq items (their ids)




                $catHeadings.hide();

                for (let answer of $answers) {
                    let $a = $(answer),
                        id = parseInt($a.attr('data-cid'));

                    if (ids.indexOf(id) < 0) {
                        $a.hide();
                    } else {
                        $a.show();
                    }
                }

            };


            let resetSearch = function () {
                $noResults.hide();
                $answers.show();
                $catHeadings.show();
            };



            if ($answers && $answers.length > 0) {
                for (let answer of $answers) {
                    let $answer = $(answer),
                        title = $answer.find('.entry-title').text(),
                        id = $answer.attr('data-cid'),
                        content = $answer.find('.entry-content').text();

                    let o = {
                        'title': title,
                        'postID': id,
                        'content': content
                    };

                    data.push(o);
                }
            }



            let options = {
                id: "postID",
                shouldSort: true,
                findAllMatches: true,
                includeMatches: true,
                threshold: 0.6,
                location: 0,
                distance: 100,
                maxPatternLength: 32,
                minMatchCharLength: 2,
                keys: [
                    "title",
                    "content"
                ]
            };

            let fuse = new Fuse(data, options);

            $searchBox.on('keyup', debounce(function () {
                let searchString = $searchBox.val();

                if (searchString === '') {
                    resetSearch();
                    $fWrapper.removeClass('active-search');
                } else {
                    let results = fuse.search(searchString),
                        ids = [];

                    if (results.length < 1) {
                        $noResults.show();
                    }

                    for (let result of results) {
                        ids.push(parseInt(result.item.postID));
                    }
                    showResults(ids);
                    $fWrapper.addClass('active-search');
                }

            }, 500));
        })();

        (function () {
            $('#konfigurator-form input[type="radio"]').on('click', function() {
                let that = $(this);
                that.closest('.form-group').find('.form-check').removeClass('checked');
                that.closest('.form-check').addClass('checked');
            });

            $('#konfigurator-form input[type="radio"]:checked').closest('.form-check').addClass('checked');
        })();

        (function () {
            let $kombinacijeCarousel = $('.kombinacije-carousel  .owl-carousel');


            if ($kombinacijeCarousel.length > 0) {

                $kombinacijeCarousel.on('refreshed.owl.carousel', function () {

                    let $center = $kombinacijeCarousel.find('.owl-item.center');
                    $center.addClass('item-active');
                    $center.prev().addClass('item-active');
                    $center.next().addClass('item-active');
                });

                $kombinacijeCarousel.owlCarousel({
                    center: true,
                    items:5,
                    loop:true,
                    margin:50,
                    autoWidth:true,
                    responsive: {
                        0: {
                            center: true,
                            items:1,
                            loop:true,
                            margin:15,
                            autoWidth:true
                        },
                        1200: {
                            center: true,
                            items:5,
                            loop:true,
                            margin:50,
                            autoWidth:true,
                        }
                    }
                });

                $kombinacijeCarousel.trigger('refresh.owl.carousel');


                let idx, $item;
                $kombinacijeCarousel.on('translate.owl.carousel', function(e){
                    idx = e.item.index;
                    $item = $kombinacijeCarousel.find('.owl-item');
                    $item.removeClass('item-active');
                    $item.eq(idx).addClass('item-active');
                    $item.eq(idx-1).addClass('item-active');
                    $item.eq(idx+1).addClass('item-active');
                });

                $('.kombinacije-next').on('click', function() {
                    $kombinacijeCarousel.trigger('next.owl.carousel');
                });

                $('.kombinacije-prev').on('click', function() {
                    $kombinacijeCarousel.trigger('prev.owl.carousel');
                });
            }


        })();

        (function () {
            let $mnenjaCarousel = $('.mnenja-carousel  .owl-carousel');

            if ($mnenjaCarousel.length > 0) {

                $mnenjaCarousel.on('refreshed.owl.carousel', function () {

                    let $center = $mnenjaCarousel.find('.owl-item.center');
                    $center.addClass('item-active');
                    $center.prev().addClass('item-active');
                    $center.next().addClass('item-active');
                });

                $mnenjaCarousel.owlCarousel({
                    center: true,
                    items:5,
                    loop:true,
                    margin:50,
                    autoWidth:true,
                    responsive: {
                        0: {
                            center: true,
                            items:1,
                            loop:true,
                            margin:15,
                            autoWidth:true
                        },
                        1200: {
                            center: true,
                            items:5,
                            loop:true,
                            margin:50,
                            autoWidth:true,
                        }
                    }
                });



                let idx, $item;
                $mnenjaCarousel.on('translate.owl.carousel', function(e){
                    idx = e.item.index;
                    $item = $mnenjaCarousel.find('.owl-item');
                    $item.removeClass('item-active');
                    $item.eq(idx).addClass('item-active');
                    $item.eq(idx-1).addClass('item-active');
                    $item.eq(idx+1).addClass('item-active');
                });

                $('.mnenja-next').on('click', function() {
                    $mnenjaCarousel.trigger('next.owl.carousel');
                });

                $('.mnenja-prev').on('click', function() {
                    $mnenjaCarousel.trigger('prev.owl.carousel');
                });
            }
        })();


        (function () {
            $('.sub-menu-toggle').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                // $(this).closest('.nav-link').attr("aria-expanded","true");

                $(this).closest('.nav-link').attr('aria-expanded', function(index, attr){

                    if (!attr || attr == 'false') {
                        return true;
                    } else {
                        return false;
                    }
                });



                $(this).closest('.menu-item').toggleClass('show').children('.dropdown-menu').toggleClass('show');
            });
        })();


        $('#discount').on('change', function () {
            let $that = $(this),
                val = $that.val(),
                $noticeWrapper = $that.siblings('.notice-wrapper');

            let notice = '';

            $that.attr('disabled', true);

            if (val !== '') {
                let data = {
                    'code': val,
                };

                ajaxHelper(data, 'verify_discount').then((response) => {
                    $that.attr('disabled', false);

                    if (response.success !== true) {
                        notice = 'Prišlo je do napake';
                    } else {
                        if (response.data.valid !== true) {
                            notice = 'Koda "'+val+'" ni pravilna';
                            $that.val('');
                        } else {
                            notice = 'Koda je pravilna';
                        }
                    }


                    $noticeWrapper.html(notice);
                }, (response) => {
                    console.log(response);
                });
            }

        });


        function ajaxHelper(data, action) {
            return new Promise(function (resolve, reject) {
                if ( ! data ) {
                    reject('didnt get data object');
                }
                $.ajax({
                    url: localize.ajaxurl,
                    data: {
                        'action' : action,
                        'data' : data
                    },
                    type: 'POST',
                    success: function( response ) {
                        if ( response ) {
                            resolve(response);
                        } else {
                            reject('Something Went Wrong');
                        }
                    }
                });
            });
        }


        $('.masonry').masonry({
            columnWidth: '.grid-sizer',
            itemSelector: '.post-item',
            gutter: '.gutter-sizer',
            percentPosition: true
        });


        (function () {
            const $miniCart = $('#mini-cart'),
                  $body = $('body');

            $('#mini-cart-trigger').on('click', function (e) {
                e.preventDefault();
                let $that = $(this);

                $that.toggleClass('active');
                $miniCart.toggleClass('active');
                $body.toggleClass('prevent-scroll');
            });
        })();


        (function () {
            let sTrigger = $('#search-trigger'),
                sWrapper = $('#search-wrapper'),
                $body = $('body'),
                $overlay = $('.overlay'),
                $close = sWrapper.find('.close');

            sWrapper.open = false;
            sWrapper.toggler = function(){
                this.toggleClass('active');
                $body.toggleClass('overlay-active').toggleClass('prevent-scroll');
                sWrapper.open = !sWrapper.open;
            };
            sWrapper.closer = function() {
                this.removeClass('active');
                $body.removeClass('overlay-active').removeClass('prevent-scroll');
                sWrapper.open = false;
            };

            sTrigger.on('click', function (e) {
               e.preventDefault();
               sWrapper.toggler();
            });



            $close.add($overlay).on('click', function (e) {
                e.preventDefault();
               sWrapper.closer();
            });
        })();


        (function () {
            let $searchWrapper = $('#search-wrapper'),
                $searchForm = $searchWrapper.find('#searchform'),
                $searchInput = $searchForm.find('#s');

            $searchInput.on('change', function () {
                console.log('changed');
            });
        })();








        function setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }



        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('.m-wrapper-outer'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
        });



        /*
        ******************************************************************************************************
            Tables
        ******************************************************************************************************
        */

        $('#content table').each(function(){
            $(this).addClass('table');
        });

        (function () {
            let $table  = $('.table');
            if($table.length > 0){
                $table.each(function(i, table) {
                    $(table).wrap('<div class="table-responsive"></div>');
                });
            }
        })();



        //Extends jQuery with .animateCss() method (used for the language switcher among other things)
        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function() {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });


        (function () {
            // Javascript to enable link to tab
            var url = document.location.toString();
            if (url.match('#')) {
                $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
            }

            // Change hash for page-reload
            $('.nav-tabs a').on('shown.bs.tab', function (e) {
                history.pushState(null,null,e.target.hash);
            })
        })();



        initAutocomplete = function() {

            // Create the autocomplete object, restricting the search predictions to
            // geographical location types.
            var input = document.getElementById('locationInput');

            if (input === null) {
                return;
            }

            autocomplete = new google.maps.places.Autocomplete(input, {types: ['geocode']});
            autocomplete.setComponentRestrictions({'country': 'si'});

            // Avoid paying for data that you don't need by restricting the set of
            // place fields that are returned to just the address components.
            autocomplete.setFields(['geometry']);

            // When the user selects an address from the drop-down, populate the
            // address fields in the form.
            autocomplete.addListener('place_changed', fillInAddress);
        }();

        function fillInAddress() {
            // Get the place details from the autocomplete object.
            var place = autocomplete.getPlace();

            document.getElementById('locationLat').value = place.geometry.location.lat();
            document.getElementById('locationLng').value = place.geometry.location.lng();
        }

        $('#ponudniki-search').on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });

        jQuery('.form-group-wrapper label').click(function(e) {
            jQuery(this).closest('.form-group-wrapper').removeClass('radio-validation-error');
        });

        jQuery('.form-control').keyup(function() {
            jQuery(this).closest('.input-wrapper').removeClass('form-validation-error');
        });

        jQuery('.form-control').change(function() {
            jQuery(this).closest('.input-wrapper').removeClass('form-validation-error');
        });

        function izbiraZavarovanjaValidation(displayErrors, ignoreNonCalcFields) {
            if (displayErrors) {
                jQuery('.form-validation-error').each(function() {
                    jQuery(this).removeClass('form-validation-error');

                    jQuery(this).next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);
                });

                jQuery('.form-validation-error').each(function() {
                    jQuery(this).removeClass('radio-validation-error');
                });
            }

            let zavarovalnaVsota = jQuery('#zavarovalna_vsota');
            let tipZavarovalneVsote = jQuery('input[name="konfigurator[Premiums][LifeTermProductType]"]');
            let zavarovalnaDoba = jQuery('#InsuranceDuration');
            let tipPlacilaPremije = jQuery('input[name="konfigurator[PaymentDynamicPeriodMonth]"]');
            let datumRojstva = jQuery('#datum_rojstva_holder');
            let kadilec = jQuery('input[name="konfigurator[Customer][Attributes][Smoker]"]');
            let height = jQuery('#height');
            let weight = jQuery('#weight')
            let employmentStatus = jQuery('input[name="konfigurator[Customer][EmploymentStatusId]"]');
            let employer = jQuery('#Employer');
            let employment = jQuery('#employment-select');
            let politicallyExposed = jQuery('input[name="konfigurator[Customer][Attributes][PoliticallyExposed]"]');
            let financialBurden = jQuery('input[name="konfigurator[financial-burden]"]');
            let dependency = jQuery('input[name="konfigurator[dependency]"]');
            let trajnost = jQuery('input[name="konfigurator[trajnost]"]');
            
            let errors = [];
            let messages = [];

            if (isFieldEmpty(zavarovalnaVsota)) {
                errors.push(1);

                if (displayErrors) {
                    zavarovalnaVsota.closest('.input-wrapper').addClass('form-validation-error');
                }
            }

            if (!isRadioGroupChecked(tipZavarovalneVsote)) {
                errors.push(1);

                if (displayErrors) {
                    tipZavarovalneVsote[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
                }
            }

            if (isFieldEmpty(zavarovalnaDoba)) {
                errors.push(1);

                if (displayErrors) {
                    zavarovalnaDoba.closest('.input-wrapper').addClass('form-validation-error');
                }
            }

            if (!isRadioGroupChecked(tipPlacilaPremije)) {
                errors.push(1);

                if (displayErrors) {
                    tipPlacilaPremije[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
                }
            }

            if (isFieldEmpty(datumRojstva)) {
                errors.push(1);

                if (displayErrors) {
                    datumRojstva.closest('.input-wrapper').addClass('form-validation-error');
                }
            }

            if (!isRadioGroupChecked(kadilec)) {
                errors.push(1);

                if (displayErrors) {
                    kadilec[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
                }
            }

            if (isFieldEmpty(height)) {
                errors.push(1);

                if (displayErrors) {
                    height.closest('.input-wrapper').addClass('form-validation-error');
                }
            } else {
                let stripped = height.val().replace(' cm', '');

                if (isNaN(stripped)) {
                    errors.push(1);

                    if (displayErrors) {
                        height.closest('.input-wrapper').addClass('form-validation-error');
                    }
                }
            }

            if (isFieldEmpty(weight)) {
                errors.push(1);

                if (displayErrors) {
                    weight.closest('.input-wrapper').addClass('form-validation-error');
                }
            } else {
                let stripped = weight.val().replace(' kg', '');

                if (isNaN(stripped)) {
                    errors.push(1);

                    if (displayErrors) {
                        weight.closest('.input-wrapper').addClass('form-validation-error');
                    }
                }
            }

            if (!isRadioGroupChecked(employmentStatus)) {
                errors.push(1);

                if (displayErrors) {
                    employmentStatus[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
                }
            } else {
                let izbranTipZaposlitve = jQuery('input[name="konfigurator[Customer][EmploymentStatusId]"]:checked').val();
                
                if (izbranTipZaposlitve == 1) {
                    if (isFieldEmpty(employer)) {
                        errors.push(1);
        
                        if (displayErrors) {
                            employer.closest('.input-wrapper').addClass('form-validation-error');
                        }
                    }
                }

                if (izbranTipZaposlitve == 'EMPLOYED' || izbranTipZaposlitve == 'STUDENT' || izbranTipZaposlitve == 'STUDENT-HS') {
                    if (isFieldEmpty(employment)) {
                        errors.push(1);
        
                        if (displayErrors) {
                            employment.closest('.input-wrapper').addClass('form-validation-error');
                        }

                        /* messages.push('Manjka obvezno polje "Delo, ki ga opravljate".'); */
                    }
                }
            }

          
            if (!isRadioGroupChecked(politicallyExposed)) {
                errors.push(1);

                if (displayErrors) {
                    politicallyExposed[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
                }
            } else if (+jQuery('input[name="konfigurator[Customer][Attributes][PoliticallyExposed]"]:checked').val() == 1) {
                if (displayErrors) {
                    console.log('enter 2');

                    politicallyExposed[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');

                    politicallyExposed.parent().parent().parent().parent().find('.error-text').text(window.localize.errorTexts.sklenitev_za_politicno_izpostavljene_osebe_error_tekst);
                }

                messages.push(window.localize.errorTexts.sklenitev_za_politicno_izpostavljene_osebe_error_tekst);
                errors.push(1);
            }

            if (!ignoreNonCalcFields) {
                if (!isRadioGroupChecked(financialBurden)) {
                    errors.push(1);

                    if (displayErrors) {
                        financialBurden[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
                    }
                }
          

                if (!isRadioGroupChecked(dependency)) {
                    errors.push(1);

                    if (displayErrors) {
                        dependency[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
                    }
                }

                if (!isRadioGroupChecked(trajnost)) {
                    errors.push(1);

                    if (displayErrors) {
                        trajnost[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
                    }
                }
            }


            if (!isFieldEmpty(zavarovalnaDoba)) {
                let parsedZavarovalnaDoba = +zavarovalnaDoba.val();

                if (parsedZavarovalnaDoba > 40) {
                    if (displayErrors) {
                        zavarovalnaDoba.closest('.input-wrapper').addClass('form-validation-error');

                        zavarovalnaDoba.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najdaljsa_zavarovalna_doba_error_tekst);
                    }

                    messages.push(localize.errorTexts.najdaljsa_zavarovalna_doba_error_tekst);
                    errors.push(1);
                } else if (parsedZavarovalnaDoba < 5) {
                    if (displayErrors) {
                        zavarovalnaDoba.closest('.input-wrapper').addClass('form-validation-error');

                        zavarovalnaDoba.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najkrajsa_zavarovalna_doba_error_tekst);
                    }

                    messages.push(localize.errorTexts.najkrajsa_zavarovalna_doba_error_tekst);
                    errors.push(1);
                }
            }

            

            zavarovalnaVsota = jQuery('#zavarovalna_vsota');
            let employmentStatusId = jQuery('input[name="konfigurator[Customer][EmploymentStatusId]"]:checked');
            
            employment = jQuery('#employment-select');
    
            let parsedZavarovalnaVsota = unconvertNumber(zavarovalnaVsota.val());
    
            tipZavarovalneVsote = jQuery('input[name="konfigurator[Premiums][LifeTermProductType]"]');
    
            let parsedTipZavarovalneVsote = jQuery('input[name="konfigurator[Premiums][LifeTermProductType]"]:checked').val();
    
            zavarovalnaDoba = jQuery('#InsuranceDuration');
    
            let birthDate = jQuery('#datum_rojstva_holder');
    
            let starost = getAgeFromDate(birthDate.val());

            let izbranNacinPlacila = jQuery('input[name="konfigurator[PaymentDynamicPeriodMonth]"]:checked');

            if (
                employmentStatusId.val() === 'STUDENT-HS' &&
                employment.val() === 'DIJAK'
            ) {
                if (parsedZavarovalnaVsota > 35000) {
                    
                    if (displayErrors) {
                        zavarovalnaVsota.closest('.input-wrapper').addClass('form-validation-error');
                        zavarovalnaVsota.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najvisja_zavarovalna_vsota_dijaki_error_tekst);
                    }

                    messages.push(localize.errorTexts.najvisja_zavarovalna_vsota_dijaki_error_tekst);
                    errors.push(1);
                }
            } else {
                if (
                    parsedZavarovalnaVsota > 1000000
                ) {
                    
                    if (displayErrors) {
                        zavarovalnaVsota.closest('.input-wrapper').addClass('form-validation-error');
                        zavarovalnaVsota.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najvisja_zavarovalna_vsota_error_tekst);
                    }

                    messages.push(localize.errorTexts.najvisja_zavarovalna_vsota_error_tekst);
                    errors.push(1);
                } else if (
                    parsedTipZavarovalneVsote === 'norm' //&&
                   // parsedZavarovalnaVsota < 30000
                ) {
                    if (
                        izbranNacinPlacila.val() === '0' &&
                        parsedZavarovalnaVsota < 30000
                    ) {
                        //enkratno plačilo
                   
                        if (displayErrors) {
                            zavarovalnaVsota.closest('.input-wrapper').addClass('form-validation-error');
                            zavarovalnaVsota.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najnizja_zavarovalna_vsota_za_stalno_zavarovalno_vsoto_error_tekst);
                        }
    
                        messages.push(errorTexts.najnizja_zavarovalna_vsota_za_stalno_zavarovalno_vsoto_error_tekst);
                        errors.push(1);   
                    } else if (parsedZavarovalnaVsota < 1000) {
                        if (displayErrors) {
                            zavarovalnaVsota.closest('.input-wrapper').addClass('form-validation-error');
                            zavarovalnaVsota.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najvisja_zavarovalna_vsota_error_tekst);
                        }
    
                        messages.push(localize.errorTexts.najvisja_zavarovalna_vsota_error_tekst);
                        errors.push(1);
                    }
                } else if (
                    parsedTipZavarovalneVsote === 'desc' &&
                    parsedZavarovalnaVsota < 50000
                ) {
                    
                    if (displayErrors) {
                        zavarovalnaVsota.closest('.input-wrapper').addClass('form-validation-error');
                        zavarovalnaVsota.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najnizja_zavarovalna_vsota_za_padajoco_zavarovalno_vsoto_error_tekst);
                    }

                    messages.push(localize.errorTexts.najnizja_zavarovalna_vsota_za_padajoco_zavarovalno_vsoto_error_tekst);
                    errors.push(1);
                }
            }

            if (starost < 14) {
                if (displayErrors) {
                    birthDate.closest('.input-wrapper').addClass('form-validation-error');
                    birthDate.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.starost_manjsa_od_18_error_tekst);
                }

                messages.push(localize.errorTexts.starost_manjsa_od_18_error_tekst);
                errors.push(1);
            } else if (starost < 14) {
                if (displayErrors) {
                    birthDate.closest('.input-wrapper').addClass('form-validation-error');
                    birthDate.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najnizja_pristopna_starost_error_tekst);
                }

                messages.push(localize.errorTexts.najnizja_pristopna_starost_error_tekst);
                errors.push(1);
            } else if (starost > 70) {
                if (displayErrors) {
                    birthDate.closest('.input-wrapper').addClass('form-validation-error');
                    birthDate.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najvisja_pristopna_starost_error_tekst);
                }

                messages.push(localize.errorTexts.najvisja_pristopna_starost_error_tekst);
                errors.push(1);
            } else if (birthDate.val() !== '' && zavarovalnaDoba.val() !== '') {
                if (starost + parseInt(zavarovalnaDoba.val()) > 75) {
                    if (displayErrors) {
                        zavarovalnaDoba.closest('.input-wrapper').addClass('form-validation-error');
                        zavarovalnaDoba.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.starost_ob_poteku_zavarovanja_error_tekst);
                    }

                    messages.push(localize.errorTexts.starost_ob_poteku_zavarovanja_error_tekst);
                    errors.push(1);
                }
            }

            return {
                errors: errors,
                messages: messages
            };
        }

        $('#finalize-selection').click(function(e) {
            e.preventDefault();

            let validationResults = izbiraZavarovanjaValidation(true);

            let { errors, messages } = validationResults;
            
            if (errors.length) {
                scrollToError();
            }

            if (!errors.length) {
                let izbranTipPlacilaPremije = jQuery('input[name="konfigurator[PaymentDynamicPeriodMonth]"]:checked');
                let zavarovalnaVsota = jQuery('#zavarovalna_vsota');

                if (
                    zavarovalnaVsotaResponse !== null &&
                    izbranTipPlacilaPremije.val() == '12' &&
                    zavarovalnaVsotaResponse < 5 &&
                    jQuery('#employment-select').val() !== 'DIJAK'
                ) {
                    errors.push(1);
    
                    zavarovalnaVsota.closest('.input-wrapper').addClass('form-validation-error');
                    zavarovalnaVsota.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najnizja_mesecna_premija_error_tekst);
                }
    
                console.log(zavarovalnaVsotaResponse);
                console.log(izbranTipPlacilaPremije.val());

                if (
                    zavarovalnaVsotaResponse !== null &&
                    izbranTipPlacilaPremije.val() == '1' &&
                    zavarovalnaVsotaResponse < 48 &&
                    jQuery('#employment-select').val() !== 'DIJAK'
                ) {
                    errors.push(1);
                  
                    zavarovalnaVsota.closest('.input-wrapper').addClass('form-validation-error');
                    zavarovalnaVsota.closest('.input-wrapper').next('.error-text').text(localize.errorTexts.najnizja_letna_premija_error_tekst);
                }

                if (errors.length) {
                    scrollToError();
                }

                if (!errors.length) {
                    showInformationPopup();
                }
            }
        });

        function scrollToError() {
            
            let errorFields = jQuery('.form-validation-error, .radio-validation-error');

            if (errorFields.length) {
                console.log('scrolling');
                errorFields.each(function() {
                    let that = jQuery(this);

                    jQuery([document.documentElement, document.body]).animate({
                        scrollTop: that.offset().top - jQuery('#wrapper-navbar').height() -50
                    }, 500);

                    return false;
                });
            }

          /*   var scrollTo = errorFields[0];

            jQuery([document.documentElement, document.body]).animate({
                scrollTop: scrollTo.offset().top
            }, 2000); */
        }

        function validateIzbiraZavarovanja() {
          /*   jQuery('.form-validation-error').each(function() {
                jQuery(this).removeClass('form-validation-error');

                jQuery(this).siblings('.error-text').text('To polje je obvezno');
            });

            jQuery('.form-validation-error').each(function() {
                jQuery(this).removeClass('radio-validation-error');
            }); */

            let zavarovalnaVsota = jQuery('#zavarovalna_vsota');
            let tipZavarovalneVsote = jQuery('input[name="konfigurator[Premiums][LifeTermProductType]"]');
            let zavarovalnaDoba = jQuery('#InsuranceDuration');
            let tipPlacilaPremije = jQuery('input[name="konfigurator[PaymentDynamicPeriodMonth]"]');
            let datumRojstva = jQuery('#datum_rojstva_holder');
            let kadilec = jQuery('input[name="konfigurator[Customer][Attributes][Smoker]"]');
            let height = jQuery('#height');
            let weight = jQuery('#weight')
            let employmentStatus = jQuery('input[name="konfigurator[Customer][EmploymentStatusId]"]');
            let employer = jQuery('#Employer');
            let employment = jQuery('#employment-select');
            let politicallyExposed = jQuery('input[name="konfigurator[Customer][Attributes][PoliticallyExposed]"]');
            let financialBurden = jQuery('input[name="konfigurator[financial-burden]"]');
            let dependency = jQuery('input[name="konfigurator[dependency]"]')
            
            let errors = [];

            if (isFieldEmpty(zavarovalnaVsota)) {
                errors.push(1);

           /*      zavarovalnaVsota.closest('.input-wrapper').addClass('form-validation-error'); */
            }

            if (!isRadioGroupChecked(tipZavarovalneVsote)) {
                errors.push(1);

            /*     tipZavarovalneVsote[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error'); */
            }

            if (isFieldEmpty(zavarovalnaDoba)) {
                errors.push(1);

            /*     zavarovalnaDoba.closest('.input-wrapper').addClass('form-validation-error'); */
            }
 
            if (!isRadioGroupChecked(tipPlacilaPremije)) {
                errors.push(1);
/* 
                tipPlacilaPremije[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error'); */
            }

            if (isFieldEmpty(datumRojstva)) {
                errors.push(1);
/* 
                datumRojstva.closest('.input-wrapper').addClass('form-validation-error'); */
            }

            if (!isRadioGroupChecked(kadilec)) {
                errors.push(1);

   /*              kadilec[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error'); */
            }

            if (isFieldEmpty(height)) {
                errors.push(1);

        /*         height.closest('.input-wrapper').addClass('form-validation-error'); */
            } else {
                let stripped = height.val().replace(' cm', '');

                if (isNaN(stripped)) {
                    errors.push (1);

               /*      height.closest('.input-wrapper').addClass('form-validation-error'); */
                }
            }

            if (isFieldEmpty(weight)) {
                errors.push(1);

          /*       weight.closest('.input-wrapper').addClass('form-validation-error'); */
            } else {
                let stripped = weight.val().replace(' kg', '');

                if (isNaN(stripped)) {
                    errors.push (1);

                    /* weight.closest('.input-wrapper').addClass('form-validation-error'); */
                }
            }

            if (!isRadioGroupChecked(employmentStatus)) {
                errors.push(1);

              /*   employmentStatus[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error'); */
            } else {
                let izbranTipZaposlitve = jQuery('input[name="konfigurator[Customer][EmploymentStatusId]"]:checked').val();
                
                if (izbranTipZaposlitve == 1) {
                    if (isFieldEmpty(employer)) {
                        errors.push(1);
        
                        /* employer.closest('.input-wrapper').addClass('form-validation-error'); */
                    }
                }

                if (izbranTipZaposlitve == 1 || izbranTipZaposlitve == 3) {
                    if (isFieldEmpty(employment)) {
                        errors.push(1);
        
                      /*   employment.closest('.input-wrapper').addClass('form-validation-error'); */
                    }
                }
            }

         /*    jQuery('#zavarovalna_vsota, #InsuranceDuration, #datum_rojstva_holder, #height, #weight, #Employer, #employment-select, #hoby-select').on('focusout', function() {console.log('focus out');
                jQuery(this).attr('data-was-focused', true);
            }); */

            if (!isRadioGroupChecked(politicallyExposed)) {
                errors.push(1);

                /* politicallyExposed[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error'); */
            }

        /*     if (!isRadioGroupChecked(financialBurden)) {
                errors.push(1);

                financialBurden[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
            }

            if (!isRadioGroupChecked(dependency)) {
                errors.push(1);

                dependency[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
            } */

            if (!isFieldEmpty(zavarovalnaVsota) && isRadioGroupChecked(tipZavarovalneVsote)) {
                let parsedZavarovalnaVsota = parseFloat(zavarovalnaVsota.val().replace('.', '').replace(',', '.'));
                let selectedTipZavarovalneVsote = jQuery('input[name="konfigurator[Premiums][LifeTermProductType]"]:checked').val();

                let minVal = null;

                switch (selectedTipZavarovalneVsote) {
                    case 'norm':
                        minVal = 30000;

                        break;
                    case 'desc':
                        minVal = 50000;

                        break;
                }

                if (parsedZavarovalnaVsota < minVal) {
                    errors.push(1);
          /*           
                    zavarovalnaVsota.closest('.input-wrapper').addClass('form-validation-error');

                    zavarovalnaVsota.closest('.input-wrapper').next('.error-text').text(`Minimalna zavarovalna vsota je ${minVal}.`); */
                }

            }

            if (!isFieldEmpty(zavarovalnaDoba)) {
                let parsedZavarovalnaDoba = +zavarovalnaDoba;

                if (parsedZavarovalnaDoba < 5 || parsedZavarovalnaDoba > 40) {
               /*      zavarovalnaDoba.closest('.input-wrapper').addClass('form-validation-error'); */

                    errors.push(1);
                }
            }

            return errors;
        }

        jQuery('input[name="konfigurator[Customer][EmploymentStatusId]"]').change(function() {
            setEmploymentSelectionOption();
        });

        if (jQuery('input[name="konfigurator[Customer][EmploymentStatusId]"]:checked').length) {
            let occupationId = jQuery('#employment-select').find(':selected').data('occupationid');

            setEmploymentSelectionOption();

            jQuery(`#employment-select option[data-occupationid=${occupationId}]`).prop('selected', true);
        }


        $('#konf-submit-btn').click(function(e) {
            jQuery('.form-validation-error').each(function() {
                jQuery(this).removeClass('form-validation-error');
            });

            let urlParams = new URLSearchParams(window.location.search);
            let step = urlParams.get('step');

            if (step == 1 || step == null) {
                errors = validateStep1();
            } else if (step == 2) {
                errors = validateStep2();
            } else if (step == 3) {
                errors = validateStep3();
            } else if (step == 4) {
                errors = validateStep4();
            } else if (step == 5) {
                errors = validateStep5();
            } else if (step == 6) {
                errors = validateStep6();
            }

            if (errors.length) {
                scrollToError();

                e.preventDefault();
            } else {
                showLoadingPopup();
            }
        });

        function validateStep6() {
            let errors = [];

            let pogojiSklenitve = jQuery('#pogoji_sklenitve');

            if (!isCheckboxChecked(pogojiSklenitve)) {
                errors.push(1);

                pogojiSklenitve.addClass('form-validation-error');
            }

            return errors;
        }

        function validateStep5() {
            let errors = [];

            let nacinPlacila = jQuery('input[name="konfigurator[PaymentPlanList][DocumentPaymentTypeId]"]');

            if (!isRadioGroupChecked(nacinPlacila)) {
                errors.push(1);

                nacinPlacila[0].parentElement.parentElement.parentElement.classList.add('radio-validation-error');
            } else {
                if (jQuery('input[name="konfigurator[PaymentPlanList][DocumentPaymentTypeId]"]:checked').val() == "14") {
                    let stRacuna = jQuery('#Iban');
                    let swift = jQuery('#Bic');
                    let nazivBanke = jQuery('#BankName');
                    let soglasjeZaBremenitev = jQuery('#soglasjeBremenitev');

                    if (isFieldEmpty(stRacuna)) {
                        errors.push(1);

                        stRacuna.closest('.input-wrapper').addClass('form-validation-error');
                    }

                    if (isFieldEmpty(swift)) {
                        errors.push(1);

                        swift.closest('.input-wrapper').addClass('form-validation-error');
                    }

                    if (isFieldEmpty(nazivBanke)) {
                        errors.push(1);

                        nazivBanke.closest('.input-wrapper').addClass('form-validation-error');
                    }

                    if (!isCheckboxChecked(soglasjeZaBremenitev)) {
                        errors.push(1);

                        soglasjeZaBremenitev.addClass('form-validation-error');
                    }
                }
            }

            return errors;
        }

        function validateStep4() {
            let errors = [];

            let vkljucitevUpnikov = jQuery('input[name="konfigurator[VinculationObj][VinculateOffer]"]:checked');

            if (vkljucitevUpnikov.val() == 1) {
                let vrstaUpnika = jQuery('#IsCompany');

                let ulicaUpnika = jQuery('#ulica');
                let histnaStUpnika = jQuery('#hisna_st');
                let postaUpnika = jQuery('#posta');
                let krajUpnika = jQuery('#kraj');

                let davcnaStevilkaUpnika = jQuery('#davcna_st');

                let stKreditnePogodbe = jQuery('#CreditContractNumber');
                let visinaKredita = jQuery('#VinculationSum');

                if (isFieldEmpty(vrstaUpnika)) {
                    errors.push(1);

                    vrstaUpnika.closest('.input-wrapper').addClass('form-validation-error');
                } else {
                    switch (vrstaUpnika.val()) {
                        case "0": 
                            let imeUpnika = jQuery('#ime');
                            let priimekUpnika = jQuery('#priimek');

                            if (isFieldEmpty(imeUpnika)) {
                                errors.push(1);
                                
                                imeUpnika.closest('.input-wrapper').addClass('form-validation-error');
                            }

                            if (isFieldEmpty(priimekUpnika)) {
                                errors.push(1);
                                
                                priimekUpnika.closest('.input-wrapper').addClass('form-validation-error');
                            }

                            break;
                        case "1": 
                            let nazivInstitucijeUpnika = jQuery('#legalname');

                            if (isFieldEmpty(nazivInstitucijeUpnika)) {
                                errors.push(1);
            
                                nazivInstitucijeUpnika.closest('.input-wrapper').addClass('form-validation-error');
                            }

                            break;
                    }
                }

                if (isFieldEmpty(ulicaUpnika)) {
                    errors.push(1);

                    ulicaUpnika.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(histnaStUpnika)) {
                    errors.push(1);

                    histnaStUpnika.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(postaUpnika)) {
                    errors.push(1);

                    postaUpnika.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(krajUpnika)) {
                    errors.push(1);

                    krajUpnika.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(davcnaStevilkaUpnika)) {
                    errors.push(1);

                    davcnaStevilkaUpnika.parent().next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);
                    davcnaStevilkaUpnika.closest('.input-wrapper').addClass('form-validation-error');
                } else if (!RE.util.Validators.isValidTaxNumber(davcnaStevilkaUpnika.val())) {
                    errors.push(1);
                
                    davcnaStevilkaUpnika.parent().next('.error-text').html('Davčna številka ni veljavna');
                    davcnaStevilkaUpnika.closest('.input-wrapper').addClass('form-validation-error');
                }



                
                if (isFieldEmpty(stKreditnePogodbe)) {
                    errors.push(1);

                    stKreditnePogodbe.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(visinaKredita)) {
                    errors.push(1);

                    visinaKredita.closest('.input-wrapper').addClass('form-validation-error');
                }
            }

            return errors;
        }

        function validateStep3() {
            let errors = [];

            let tipUpravicenca = jQuery('input[name="konfigurator[Beneficiary][Type]"]:checked').val();

            if (tipUpravicenca === 'custom') {
                let imeUpravicenca = jQuery('#ime');
                let priimekUpravicenca = jQuery('#priimek');
                let spolUpravicenca = jQuery('input[name="konfigurator[Beneficiary][Gender]"]')
                let datumRojstvaUpravicenca = jQuery('#datum_rojstva_Beneficiary');
                let krajRojstvaUpravicenca = jQuery('#BirthPlace');
                let drzavaRojstvaUpravicenca = jQuery('#BirthCountryId');

                if (isFieldEmpty(imeUpravicenca)) {
                    errors.push(1);

                    imeUpravicenca.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(priimekUpravicenca)) {
                    errors.push(1);

                    priimekUpravicenca.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (!isCheckboxChecked(spolUpravicenca)) {
                    errors.push(1);

                    spolUpravicenca[0].parentElement.parentElement.parentElement.classList.add('radio-validation-error');
                }

                if (isFieldEmpty(datumRojstvaUpravicenca)) {
                    errors.push(1);

                    datumRojstvaUpravicenca.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(krajRojstvaUpravicenca)) {
                    errors.push(1);

                    krajRojstvaUpravicenca.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(drzavaRojstvaUpravicenca)) {
                    errors.push(1);

                    drzavaRojstvaUpravicenca.closest('.input-wrapper').addClass('form-validation-error');
                }
            }

            return errors;
        }

        function validateStep2() {
            let errors = [];

            let osebniZdravnikIme = jQuery('#ime');
            let osebniZdravnikPriimek = jQuery('#priimek');

            let imeZdravstveneUstanove = jQuery('#DoctorOffice');
            let ulicaZdravstveneUstanove = jQuery('#DoctorAddressStreet');
            let histnaStZdravstveneUstanove = jQuery('#hisna_st');
            let postnaStZdravstveneUstanove = jQuery('#posta');
            let krajZdravstveneUstanove = jQuery('#kraj');

            /* let emailZdravnika = jQuery('#payer-email'); */
            let telefonZdravnika = jQuery('#payer-phone');

            if (isFieldEmpty(osebniZdravnikIme)) {
                errors.push(1);

                osebniZdravnikIme.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(osebniZdravnikPriimek)) {
                errors.push(1);

                osebniZdravnikPriimek.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(imeZdravstveneUstanove)) {
                errors.push(1);

                imeZdravstveneUstanove.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(ulicaZdravstveneUstanove)) {
                errors.push(1);

                ulicaZdravstveneUstanove.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(histnaStZdravstveneUstanove)) {
                errors.push(1);

                histnaStZdravstveneUstanove.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(postnaStZdravstveneUstanove)) {
                errors.push(1);

                postnaStZdravstveneUstanove.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(krajZdravstveneUstanove)) {
                errors.push(1);

                krajZdravstveneUstanove.closest('.input-wrapper').addClass('form-validation-error');
            }

            /* if (isFieldEmpty(emailZdravnika)) {
                errors.push(1);

                emailZdravnika.addClass('form-validation-error');
            } */

            if (isFieldEmpty(telefonZdravnika)) {
                errors.push(1);

                telefonZdravnika.parent().next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);
                telefonZdravnika.closest('.input-wrapper').addClass('form-validation-error');
            } else if (!isPhoneNumberValid(telefonZdravnika.val())) {
                errors.push(1);

                telefonZdravnika.parent().next('.error-text').html('Telefonska številka ni veljavna');
                telefonZdravnika.closest('.input-wrapper').addClass('form-validation-error');
            } 

            return errors;
        }

        function validateStep1() {
            let errors = [];

            let ime = jQuery('#ime');
            let priimek = jQuery('#priimek');
            let spol = jQuery('input[name="konfigurator[Holder][Gender]"]');
            let krajRojstva = jQuery('#BirthPlace');
            let drzavaRojstva = jQuery('#BirthCountryId');
            let drzavljanstvo = jQuery('#CitizenshipCountryId');
            let davcna = jQuery('#davcna_st');

            let ulica = jQuery('#ulica');
            let hisnaSt = jQuery('#hisna_st');
            let postnaSt = jQuery('#posta');
            let kraj = jQuery('#kraj');

            let naslovZaVrocanje = jQuery('input[name="konfigurator[Holder][Postal]"]:checked');

            let email = jQuery('#holder-email');
            let phoneNumber = jQuery('#holder-phone');

            let nacinVzpostavitveStika = jQuery('input[name="konfigurator[GDPR][ContactType]"]');

            let vrstaDokumenta = jQuery('#DocumentType');
            let stevilkaDokumenta = jQuery('#DocumentNumber');

            let dokumentVeljavnostOd = jQuery('#veljavnost_od_holder');
            let dokumentVeljavnostDo = jQuery('#veljavnost_do_holder');

            let izdajateljDokument = jQuery('#DocumentIssuer');

            let strinjanjePolitikaZasebnosti = jQuery('#politika_sasebnosti');

            let vrocanjeUlica = jQuery('#ulica-postal');
            let vrocanjeHistnaSt = jQuery('#hisna_st-postal');
            let vrocanjePostnaSt = jQuery('#posta-postal');
            let vrocanjeKraj = jQuery('#kraj-postal');

            if (isFieldEmpty(ime)) {
                errors.push(1);

                ime.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(priimek)) {
                errors.push(1);
                
                priimek.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (!isRadioGroupChecked(spol)) {
                errors.push(1);

                spol[0].parentElement.parentElement.parentElement.classList.add('radio-validation-error');
            }

            if (isFieldEmpty(krajRojstva)) {
                errors.push(1);
                
                krajRojstva.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(drzavaRojstva)) {
                errors.push(1);
                
                drzavaRojstva.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(drzavljanstvo)) {
                errors.push(1);
                
                drzavljanstvo.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(davcna)) {
                errors.push(1);
                
                davcna.closest('.input-wrapper').addClass('form-validation-error');
                davcna.parent().next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);
            } else if (!RE.util.Validators.isValidTaxNumber(davcna.val())) {
                errors.push(1);
                
                davcna.parent().next('.error-text').html('Davčna številka ni veljavna');
                davcna.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(ulica)) {
                errors.push(1);
                
                ulica.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(hisnaSt)) {
                errors.push(1);
                
                hisnaSt.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(postnaSt)) {
                errors.push(1);
                
                postnaSt.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(kraj)) {
                errors.push(1);
                
                kraj.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (naslovZaVrocanje.val() === 'different') {
                if (isFieldEmpty(vrocanjeUlica)) {
                    errors.push(1);
                    
                    vrocanjeUlica.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(vrocanjeHistnaSt)) {
                    errors.push(1);
                    
                    vrocanjeHistnaSt.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(vrocanjePostnaSt)) {
                    errors.push(1);
                    
                    vrocanjePostnaSt.closest('.input-wrapper').addClass('form-validation-error');
                }

                if (isFieldEmpty(vrocanjeKraj)) {
                    errors.push(1);
                    
                    vrocanjeKraj.closest('.input-wrapper').addClass('form-validation-error');
                }
            }

            if (!isRadioGroupChecked(nacinVzpostavitveStika)) {
                errors.push(1);

                nacinVzpostavitveStika[0].parentElement.parentElement.parentElement.parentElement.classList.add('radio-validation-error');
            } else {
                switch (nacinVzpostavitveStika.val()) {
                    case 'both': 
                        if (isFieldEmpty(email)) {
                            errors.push(1);

                            email.parent().next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);
                            email.closest('.input-wrapper').addClass('form-validation-error');
                        } else if (!isEmailValid(email.val())) {
                            errors.push(1);

                            email.parent().next('.error-text').html('E poštni naslov ni veljaven');
                            email.closest('.input-wrapper').addClass('form-validation-error');
                        }

                        if (isFieldEmpty(phoneNumber)) {
                            errors.push(1);

                            phoneNumber.parent().next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);
                            phoneNumber.closest('.input-wrapper').addClass('form-validation-error');
                        } else if (!isPhoneNumberValid(phoneNumber.val())) {
                            errors.push(1);

                            phoneNumber.parent().next('.error-text').html('Telefonska številka ni veljavna');
                            phoneNumber.closest('.input-wrapper').addClass('form-validation-error');
                        }
                        break;
                    case 'email': 
                        if (isFieldEmpty(email)) {
                            errors.push(1);

                            email.parent().next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);
                            email.closest('.input-wrapper').addClass('form-validation-error');
                        } else if (!isEmailValid(email.val())) {
                            errors.push(1);

                            email.parent().next('.error-text').html('E poštni naslov ni veljaven');
                            email.closest('.input-wrapper').addClass('form-validation-error');
                        }

                        break;
                    case 'phone':
                        if (isFieldEmpty(phoneNumber)) {
                            errors.push(1);

                            phoneNumber.parent().next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);
                            phoneNumber.closest('.input-wrapper').addClass('form-validation-error');
                        } else if (!isPhoneNumberValid(phoneNumber.val())) {
                            errors.push(1);

                            phoneNumber.parent().next('.error-text').html('Telefonska številka ni veljavna');
                            phoneNumber.closest('.input-wrapper').addClass('form-validation-error');
                        }

                        break;
                }
            }

            if (isFieldEmpty(vrstaDokumenta)) {
                errors.push(1);

                vrstaDokumenta.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(stevilkaDokumenta)) {
                errors.push(1);

                stevilkaDokumenta.parent().next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);

                stevilkaDokumenta.closest('.input-wrapper').addClass('form-validation-error');
            } else if (stevilkaDokumenta.val().length !== 9) {
                errors.push(1);

                stevilkaDokumenta.parent().next('.error-text').html('Številka dokumenta mora vsebovati 9 znakov.');

                stevilkaDokumenta.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(dokumentVeljavnostOd)) {
                errors.push(1);

                dokumentVeljavnostOd.parent().next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);
                dokumentVeljavnostOd.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (isFieldEmpty(dokumentVeljavnostDo)) {
                errors.push(1);

                dokumentVeljavnostDo.parent().next('.error-text').html(localize.errorTexts.obvezno_polje_error_tekst);
                dokumentVeljavnostDo.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (!isFieldEmpty(dokumentVeljavnostOd) && !isFieldEmpty(dokumentVeljavnostDo)) {
                let dateFrom = Date.parse(formatDateString(dokumentVeljavnostOd.val()));
                let dateTo = Date.parse(formatDateString(dokumentVeljavnostDo.val()));

                let currentDate = new Date();

                if (
                    (dateFrom > currentDate || dateTo < currentDate) ||
                    dateTo < dateFrom
                ) {
                    errors.push(1);

                    dokumentVeljavnostOd.closest('.input-wrapper').addClass('form-validation-error');
                    dokumentVeljavnostOd.parent().next('.error-text').html('Dokument ni veljaven.');
                }
            }

            if (isFieldEmpty(izdajateljDokument)) {
                errors.push(1);

                izdajateljDokument.closest('.input-wrapper').addClass('form-validation-error');
            }

            if (!isCheckboxChecked(strinjanjePolitikaZasebnosti)) {
                errors.push(1);

                strinjanjePolitikaZasebnosti.closest('.input-wrapper').addClass('form-validation-error');
            }

            return errors;
        }

        function formatDateString(str) {
            let chunks = str.split('.');

            chunks = chunks.reverse();

            return chunks.join('-');
        }

        function isFieldEmpty(field) {
            return field.val() === '' || field.val() === null;
        }

        function isRadioGroupChecked(radioGroup) {
            for (let e of radioGroup) {
                if (e.checked) {
                    return true;
                }
            };

            return false;
        }

        function isCheckboxChecked(field) {
            return field.is(':checked');
        }

        function isEmailValid(elementValue){      
            let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

            return emailPattern.test(elementValue); 
        }

        function isPhoneNumberValid(val) {
            let pattern = /[\d]{9}/;

            return pattern.test(val) && val.length === 9 && val.startsWith(0);
        }


        jQuery('.height-field').change(function() {
            if (jQuery(this).val() !== '') {
                if (jQuery(this).val().indexOf('cm') === -1) {
                    jQuery(this).val(`${jQuery(this).val()} cm`);
                }
            } else {
                jQuery(this).val('');
            }
        });

        jQuery('.weight-field').change(function() {
            if (jQuery(this).val() !== '') {
                if (jQuery(this).val().indexOf('kg') === -1) {
                    jQuery(this).val(`${jQuery(this).val()} kg`);
                }
            } else {
                jQuery(this).val('');
            }
        });

        jQuery('.informativni-izracun-form .form-check-label').click(function() {
            let that = jQuery(this);

            that.closest('.form-group').find('.form-check').removeClass('checked');
            that.closest('.form-check').addClass('checked');
        });

        jQuery('.informativni-izracun-form .form-check').click(function() {
            jQuery('.conditional-fields').each(function() {
                jQuery(this).addClass('d-none');
            });

            let target = jQuery(this).attr('data-conditional');

            if (target !== 'undefined') {
                jQuery(target).removeClass('d-none');
            }
        });

        jQuery('.informativni-izracun-form').change(function(e) {
            errors = validateInformativniIzracun();

            if (!errors.length) {
                jQuery('#submit-informativni-izracun').attr('disabled', false);
            } else {
                jQuery('#submit-informativni-izracun').attr('disabled', true);
            }
        });

        jQuery('.informativni-izracun-form').submit(function(e) {
            e.preventDefault();
            
            let osebniDohodek = jQuery('#vas-osebni-dohodek');
            let starostNajmlajsegaOtroka = jQuery('#starost-najmlajsega-otroka');

            let imaKredit = jQuery('input[name="ima-kredit"]:checked');

            let vsotaVsehFinancnihObveznosti = jQuery('#vsota-vseh-financnih-obveznosti');
            let dobaOdplacevanjaKredita = jQuery('#doba-odplacevanja-kredita');

            let zavarovalnaVsota = null;
            let zavarovalnaDoba = null;

            let parsedOsebniDohodek = unconvertNumber(osebniDohodek.val());
            let parsedVsotaVsehFinancnihObveznosti = unconvertNumber(vsotaVsehFinancnihObveznosti.val());

            if (imaKredit.val() == "da") {
                let calcStarost = 25 - +starostNajmlajsegaOtroka.val();

                zavarovalnaDoba = Math.max(+dobaOdplacevanjaKredita.val(), calcStarost);

                zavarovalnaVsota = (parsedOsebniDohodek * 36) + +parsedVsotaVsehFinancnihObveznosti;
            } else {
                zavarovalnaVsota = parsedOsebniDohodek * 36;
                zavarovalnaDoba = (25 - +starostNajmlajsegaOtroka.val());
            }

            zavarovalnaVsota = convertNumber(zavarovalnaVsota);

            jQuery('.zavarovalna-vsota').html(zavarovalnaVsota + ' €');
            jQuery('.zavarovalna-doba').html(zavarovalnaDoba + ' let');

            jQuery('.info-block-first').addClass('d-none');
            jQuery('.info-block-calculated').removeClass('d-none');
        });

        function convertNumber(n) {
            var val = Math.round(Number(n) *100) / 100;
            var parts = val.toString().split(".");
            var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + (parts[1] ? "," + parts[1] : "");

            if (num[num.length - 2] == ',') {
                num += '0';
            }

            if (num.indexOf(',') == -1) {
                num += ',00';
            }

            return num;
        }

        function unconvertNumber(val) {
            val = val.replace('.', '');
            val = val.replace(',', '.');

            if (val.split('.').length > 2) {
                let chunks = val.split('.');
          
				let constructed = '';
				
				for (let i = 0; i < chunks.length; i++) {
					if (i === chunks.length -1 ) {
						constructed += '.';    
					}
					
					constructed += chunks[i];
				}
				
				val = constructed;
			}
            

            return parseFloat(val);
        }

        function validateInformativniIzracun() {
            let errors = [];

            let osebniDohodek = jQuery('#vas-osebni-dohodek');
            let starostNajmlajsegaOtroka = jQuery('#starost-najmlajsega-otroka');

            let imaKredit = jQuery('input[name="ima-kredit"]');

            let vsotaVsehFinancnihObveznosti = jQuery('#vsota-vseh-financnih-obveznosti');
            let dobaOdplacebanjaKredita = jQuery('#doba-odplacevanja-kredita');

            if (isFieldEmpty(osebniDohodek)) {
                errors.push(1);
            }

            if (isFieldEmpty(starostNajmlajsegaOtroka)) {
                errors.push(1);
            }

            if (!isRadioGroupChecked(imaKredit)) {
                errors.push(1);
            } else {
                let selectedValue = jQuery('input[name="ima-kredit"]:checked');

                if (selectedValue.val() == 1) {
                    if (isFieldEmpty(vsotaVsehFinancnihObveznosti)) {
                        errors.push(1);
                    }

                    if (isFieldEmpty(dobaOdplacebanjaKredita)) {
                        errors.push(1);
                    }
                }
            }

            return errors;

        }

        jQuery('input, select').on('keyup change', function() {
            let length = 0;
console.log('trigger');
            if (jQuery(this).val()) {
                length = jQuery(this).val().length;
            }

            if ( !jQuery(this).hasClass('disable-label-on-click')) {
                if (length) {
                    jQuery(this).addClass('input-has-value');
                } else {
                    jQuery(this).removeClass('input-has-value');
                }
            }
        });

        jQuery('input[type="text"], input[type="number"], input[type="date"]').each(function() {

            if (jQuery(this).val().length !== 0) {
                jQuery(this).addClass('input-has-value');
            }
        });

        jQuery('select').each(function() {
            if (jQuery(this).val() !== null) {
                jQuery(this).addClass('input-has-value');
            }
        });

        /* if (jQuery('#Bic')) {
            jQuery('#Bic').attr('disabled', true);
        } */

        function showLoadingPopup() {
            jQuery('.load-popup').removeClass('d-none');
            jQuery('body').addClass('overflow-hidden');
        }

        function hideLoadingPopup() {
            jQuery('.load-popup').addClass('d-none');
            jQuery('body').removeClass('overflow-hidden');
        }

        let zavarovalnaVsotaResponse = null;
        let pricePreviewRequest = null;

        function handleIzbiraZavarovanjaAjax(onlyBottomValue = false) {
            /* if (pricePreviewRequest) {
                pricePreviewRequest.abort();
            } */

            let validationResults = izbiraZavarovanjaValidation(false, true);

            let { errors, messages } = validationResults;

            jQuery('.premium-value-error-text').addClass('d-none');
            jQuery('.premium-value-calculation-text').addClass('d-none');

            if (messages.length) {
                $('.premium-value-error-text').html(messages.join('<br>'));

                jQuery('.premium-value-error-text').removeClass('d-none');

                jQuery('.premium-value-loader').addClass('d-none');

                return false;
            }

            if (!errors.length) {
                let data = jQuery('#konfigurator-form').serialize();

                data += '&action=calculate_price_preview_ajax';

                jQuery('.premium-value-loader').removeClass('d-none');

                pricePreviewRequest = jQuery.ajax({
                    url: localize.ajaxurl,
                    method: 'POST',
                    data: data,
                    success: function(response) {
                        if (response.success) {
                            let premiumText = `${ response.result.calculatedData.MonthlyPremium } EUR`;
                            let monthlyPremium = response.result.calculatedData.MonthlyPremium;
                            let costLabelText = response.result.paymentFrequencyText;

                            let paymentType = jQuery('input[name="konfigurator[PaymentDynamicPeriodMonth]"]:checked').val();

                            jQuery('.premium-value-bottom').html(premiumText);
               
                            zavarovalnaVsotaResponse = response.result.calculatedData.MonthlyPremium;

                            if (!onlyBottomValue) {
                                jQuery('.premium-value').each(function() {
                                    jQuery(this).html(monthlyPremium + ' EUR');
                                });

                                jQuery('.cost-label').each(function() {
                                    jQuery(this).html(costLabelText);
                                });

                                jQuery('.zavarovalna-vsota').text(convertNumber(response.result.lifeTermProductSum) + ' €');
                                jQuery('.trajanje-zavarovanja').text(response.result.insuranceDuration + ' let');
                                jQuery('.premija').text(convertNumber(response.result.calculatedData.MonthlyPremium) + ' €');
                                jQuery('.davek').text(convertNumber(response.result.calculatedData.Tax) + ' €');
                                jQuery('.davek-procent').text((response.result.taxPercentage * 100) + ' %');

                                jQuery('.davek-procent-text').each(function() {
                                    jQuery(this).html(`Premija (vključen ${ response.result.taxPercentage * 100 }% DPZP)`);
                                });
                            }

                            jQuery('.premium-value-loader').addClass('d-none');
                            jQuery('.premium-value-calculation-text').removeClass('d-none');

                            let izbranTipPlacilaPremije = jQuery('input[name="konfigurator[PaymentDynamicPeriodMonth]"]:checked');
                            
                            if (
                                zavarovalnaVsotaResponse !== null &&
                                izbranTipPlacilaPremije.val() == '12' &&
                                zavarovalnaVsotaResponse < 5 &&
                                jQuery('#employment-select').val() !== 'DIJAK'
                            ) {
                                errors.push(1);
                
                                $('.premium-value-error-text').text(localize.errorTexts.najnizja_mesecna_premija_error_tekst);

                                jQuery('.premium-value-error-text').removeClass('d-none');
                            }
                            
                            if (
                                izbranTipPlacilaPremije.val() == '1' &&
                                zavarovalnaVsotaResponse < 48 &&
                                jQuery('#employment-select').val() !== 'DIJAK'
                            ) {
                                $('.premium-value-error-text').text(localize.errorTexts.najnizja_letna_premija_error_tekst);

                                jQuery('.premium-value-error-text').removeClass('d-none');
                            }
                        }
                    }
                });
            }
        }

        jQuery('#konfigurator-form').on('change', function() {
            if (jQuery('#finalize-selection').length) {
                handleIzbiraZavarovanjaAjax();
            }
        });

        if (jQuery('#konfigurator-form').length) {
            if (jQuery('#finalize-selection').length) {
                handleIzbiraZavarovanjaAjax(true);
            }
        }

        jQuery('.form-check').on('click', function() {
            jQuery(this).closest('.form-validation-error').removeClass('form-validation-error');
        });

        jQuery('#mini-cart a').on('click', function() {
            showLoadingPopup();
        });

        jQuery('.conf-controls-wrapper a').on('click', function() {
            showLoadingPopup();
        });

        jQuery('.information-popup-confirm-btn').on('click', function() {
            closeInformationPopup();
            showLoadingPopup();
            jQuery('#employment-select').removeAttr('disabled');
            jQuery('#konfigurator-form').submit();
        });

        jQuery('.close-btn').on('click', function() {
            closeInformationPopup();
        });

        function showInformationPopup() {
            jQuery('.information-popup').removeClass('d-none');
            jQuery('body').addClass('overflow-hidden');
        }

        function closeInformationPopup() {
            jQuery('.information-popup').addClass('d-none');
            jQuery('body').removeClass('overflow-hidden');
        }

   /*      function fixSideCart() {
            let footerHeight = jQuery('#wrapper-footer').height();

            jQuery('#mini-cart .card-body').css('padding-bottom', footerHeight + 'px');
        } */

         let zavarovalnaVsotaMask = null;

        if (jQuery('#zavarovalna_vsota').length) {
            zavarovalnaVsotaMask = (IMask($('#zavarovalna_vsota').get(0), {
                mask: Number,  // enable number mask
    
                // other options are optional with defaults below
                scale: 2,  // digits after point, 0 for integers
                signed: true,  // disallow negative
                thousandsSeparator: '.',  // any single char
                padFractionalZeros: true,  // if true, then pads zeros at end to the length of scale
                normalizeZeros: true,  // appends or removes zeros at ends
                radix: ',',  // fractional delimiter
                mapToRadix: ['.'],  // symbols to process as radix
    
                // additional number interval options (e.g.)
                min: 0,
            }));
        }

        jQuery('#zavarovalna_vsota').on('focusout', function() {
            let that = jQuery(this);

            setTimeout(function() {
                let val = unconvertNumber(that.val());
                that.val((Math.round(val / 1000) * 1000));

                zavarovalnaVsotaMask.destroy();

                zavarovalnaVsotaMask = (IMask($('#zavarovalna_vsota').get(0), {
                    mask: Number,  // enable number mask
        
                    // other options are optional with defaults below
                    scale: 2,  // digits after point, 0 for integers
                    signed: true,  // disallow negative
                    thousandsSeparator: '.',  // any single char
                    padFractionalZeros: true,  // if true, then pads zeros at end to the length of scale
                    normalizeZeros: true,  // appends or removes zeros at ends
                    radix: ',',  // fractional delimiter
                    mapToRadix: ['.'],  // symbols to process as radix
        
                    // additional number interval options (e.g.)
                    min: 0,
                }));
            }, 100);

            
        
        });

        $('form').on('focus', 'input[type=number]', function (e) {
            $(this).on('wheel.disableScroll', function (e) {
              e.preventDefault()
            })
        })

        $('form').on('blur', 'input[type=number]', function (e) {
            $(this).off('wheel.disableScroll')
        })
    });

    function getAgeFromDate(str) {
        let [ day, month, year ] = str.split('.');

        let date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

        return Math.floor( (Date.now() - date.getTime()) / 31557600000 );
    }

    jQuery('#IsCompany').on('change', function() {
        alterTaxNumberText();
    });

    if (jQuery('#IsCompany').length) {
        alterTaxNumberText();
    }

    function alterTaxNumberText() {
        switch (jQuery('#IsCompany').val()) {
            case '1':
                jQuery('#davcna_st').next('.floating-label').html('Davčna številka inštitucije');
            break;
            case '0':
                jQuery('#davcna_st').next('.floating-label').html('Davčna številka');
            break;
        }
    }

    jQuery('#DocumentIssuer').on('change', function() {
        jQuery('#DocumentIssuerName').val(jQuery(this).find(':selected').html().trim());
        jQuery('#DocumentIssuerCode').val(jQuery(this).find(':selected').val());
    });

    let employmentTomSelect = $('#employment-select');

    if (employmentTomSelect.length) {
        employmentTomSelect = new TomSelect('#employment-select', {
            create: false,
            closeAfterSelect: true,
            allowEmptyOption: true,
            sortField: {
                field: "text",
                direction: "asc"
            },
            maxItems: 1,
            maxOptions: null,
            render:{
                no_results:function(data,escape){
                    return '<div class="no-results">Ni rezultatov</div>';
                }
            },
            onChange: function(value) {
                if (value.length) {
                    jQuery('#employment-select').parent().find('.form-control-ts').addClass('input-has-value');
                } else {
                    jQuery('#employment-select').parent().find('.form-control-ts').removeClass('input-has-value');
                }
            },
            onInitialize: function() {
                if ($('#employment-select').val()) {
                    setTimeout(() => {
                        this.setValue([$('#employment-select').val()]);
                    }, 600);
                    
                }
            }
        });

    /*     if ($('#employment-select').val()) {
            console.log($('#employment-select').val());
            employmentTomSelect.setValue('AKTUAR');
        } */
    }

    let hobySelect = $('#hoby-select');

    if (hobySelect.length) {
        new TomSelect('#hoby-select', {
            create: false,
            closeAfterSelect: true,
            allowEmptyOption: true,
            sortField: {
                field: "text",
                direction: "asc"
            },
            maxItems: 1,
            maxOptions: null,
            render:{
                no_results:function(data,escape){
                    return '<div class="no-results">Ni rezultatov</div>';
                }
            },
            onChange: function(value) {
                if (value.length) {
                    jQuery('#hoby-select').parent().find('.form-control-ts').addClass('input-has-value');
                } else {
                    jQuery('#hoby-select').parent().find('.form-control-ts').removeClass('input-has-value');
                }
            },
            onInitialize: function() {
                if ($('#hoby-select').val()) {
                    setTimeout(() => {
                        this.setValue([$('#hoby-select').val()]);
                    }, 600);
                    
                }
            }
        });
    }

    function setEmploymentSelectionOption() {
        jQuery('#Employer').attr('disabled', false);
        jQuery('#employment-select').attr('disabled', false);
        jQuery('#employment-select').val('');
        jQuery('#employment-select').removeClass('input-has-value');

        jQuery('#employment-select option.d-none').each(function() { 
            jQuery(this).removeClass('d-none'); 
        });

        switch (jQuery('input[name="konfigurator[Customer][EmploymentStatusId]"]:checked').val()) {
            case 'EMPLOYED': 
                //zaposlen
                
                employmentTomSelect.setValue([]);
                employmentTomSelect.enable();

                break;
            case 'UNEMPLOYED':
                //brezposelni
                jQuery('#Employer').attr('disabled', true);
                jQuery('#employment-select').attr('disabled', true);

                /* jQuery('#employment-select option').each(function() {
                    if (jQuery(this).attr('data-occupationid') != localize.occupations.BREZPOSELN.OccupationId) {
                        jQuery(this).addClass('d-none'); 
                    }
                }); */

                jQuery('#employment-select').addClass('input-has-value');

                employmentTomSelect.setValue(['BREZPOSELN']);
                employmentTomSelect.disable();

                $('[name="konfigurator[Customer][Employer]"]').val('');

                break;
            case 'STUDENT':
                //študent/dijak
         
                jQuery('#Employer').attr('disabled', true);

                /* jQuery('#employment-select option').each(function() {
                    if (
                        jQuery(this).attr('data-occupationid') != localize.occupations.ŠTUDENT.OccupationId && 
                        jQuery(this).attr('data-occupationid') != localize.occupations.DIJAK.OccupationId
                    ) {
                        jQuery(this).addClass('d-none'); 
                    }
                }); */

                employmentTomSelect.setValue(['ŠTUDENT']);
                employmentTomSelect.disable();

                $('[name="konfigurator[Customer][Employer]"]').val('');

                break;
            case 'STUDENT-HS':
                //študent/dijak
         
                jQuery('#Employer').attr('disabled', true);

                /* jQuery('#employment-select option').each(function() {
                    if (
                        jQuery(this).attr('data-occupationid') != localize.occupations.ŠTUDENT.OccupationId && 
                        jQuery(this).attr('data-occupationid') != localize.occupations.DIJAK.OccupationId
                    ) {
                        jQuery(this).addClass('d-none'); 
                    }
                }); */

                employmentTomSelect.setValue(['DIJAK']);
                employmentTomSelect.disable();

                $('[name="konfigurator[Customer][Employer]"]').val('');

                break;
            case 'RETIRED':
                //upokojenec
                jQuery('#Employer').attr('disabled', true);
                jQuery('#employment-select').attr('disabled', true);

                /* jQuery('#employment-select option').each(function() {
                    if (jQuery(this).attr('data-occupationid') != localize.occupations.UPOKOJENEC.OccupationId) {
                        jQuery(this).addClass('d-none'); 
                    }
                }); */

                jQuery('#employment-select').addClass('input-has-value');

                employmentTomSelect.setValue([]);
                employmentTomSelect.enable();

                break;
        }

        if (jQuery('#employment-select option:not(.d-none)').length === 1) {
            let targetOption = jQuery('#employment-select option:not(.d-none)');
        
            jQuery('#employment-select').val(targetOption.val());

        

            $('#OccupationId').val(targetOption.attr('data-occupationid'));
            $('#RiskyOccupation').val(targetOption.attr('data-isrisk'));
            $('#OccupationRiskClass').val(targetOption.attr('data-category'));
        }
    }


})( jQuery );


